export default __webpack_public_path__ + "static/media/01_photo.e3319d40.jpg";